"use client";

import { MapPin, Settings } from "lucide-react";
import { Card, CardContent } from "@/app/_module/components/ui/card";
import { Label } from "@/app/_module/components/ui/label";
import { Switch } from "@/app/_module/components/ui/switch";
import { useDoorKnockingPreference } from "@/app/_module/hooks/useDoorKnockingPreference";

export function GeneralFeatureToggles() {
  const { doorKnockingEnabled, setDoorKnockingEnabled } = useDoorKnockingPreference();

  return (
    <Card className="border shadow-sm">
      <CardContent className="pt-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-muted">
            <Settings className="h-5 w-5" />
          </div>
          <div>
            <h3 className="text-lg font-semibold">Feature Settings</h3>
            <p className="text-sm text-muted-foreground">
              Enable or disable features based on your workflow
            </p>
          </div>
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-between rounded-lg border p-4">
            <div className="flex items-start gap-3">
              <MapPin className="h-5 w-5 mt-0.5 text-amber-600" />
              <div className="space-y-1">
                <Label htmlFor="doorKnocking" className="text-sm font-medium">
                  Door Knocking
                </Label>
                <p className="text-sm text-muted-foreground">
                  Show the Door Knock button on leads to tag and route them for field visits
                </p>
              </div>
            </div>
            <Switch
              id="doorKnocking"
              checked={doorKnockingEnabled}
              onCheckedChange={setDoorKnockingEnabled}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
